/**
 * This function replace separators to no spaces
 * from the Algolia search query
 * Frequently used separators include these characters:
 * !#()[]{}*+-_一,:;<>?@/\^|%&~£¥$§€`"'‘’“”†‡
 * Details:
 * https://www.algolia.com/doc/api-reference/api-parameters/separatorsToIndex
 * By default we will only replace '. , ' +' from the query
 * but it can be extended
 * Note: we do not pass the possible extended separators as an argument
 * to prevent possible DoS attack by not literal RegExp args.
 * @param {string} query
 * @param {separators} separatorsOverride custom sequence
 * in regular expression notation
 * @returns {string}
 */

function replaceSearchQuerySeparators(query) {
  if (!query) return '';
  const replace = new RegExp(/\.|,|'|\+|-/, 'gi');
  return query.replace(replace, ' ');
}

export default replaceSearchQuerySeparators;
